import React from 'react';

import {Label, Select, Input, Textarea} from 'Components/Form';

/*
Example...
<TravelDetails
    value={form.travel_details}
    error={getFieldError('travel_details')}
    onChange={(v) => handleInput('travel_details', v)}
/>
*/

export default class TravelDetails extends React.Component {
    /**
     * @var options
     * @type {array}
     */
    options = [
        {
            label: 'Train',
            value: 'Train'
        },
        {
            label: 'Hire Car',
            value: 'Hire Car'
        },
        {
            label: 'Own Car',
            value: 'Own Car'
        },
        {
            label: 'Plane',
            value: 'Plane'
        },
        {
            label: 'Same as Store / Deputy Manager',
            value: 'Same as Store / Deputy Manager'
        },
        {
            label: 'Other',
            value: 'Other'
        }
    ];

    /**
     * @method handleChange
     * @param {string} key
     * @param {string} v
     */
    handleChange = (key, v) =>  {
        const {value, onChange} = this.props;

        onChange({
            ...value,
            [key]: v
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            value,
            error,
            me
        } = this.props;

        return (
            <div className='flex flex-col gap-4'>
                <p className="font-bold">
                    Travel Information
                </p>

                {error &&
                    <Label
                        label=""
                        error={error}
                    />
                }

                <p className={"font-light mb-4"}>
                    Travel should be booked individually by each advisor via Concur using their OneID login details. Travel will be charged centrally. However, each individual will need to process the expense claim after the event in order to make sure your store is not charged for the travel. The charge code is 32764.
                    Communication and guidance is available on BootsLive.
                </p>

                <Select
                    label={me ?
                        "Please confirm how you will be travelling to the event?" :
                        "Please confirm how the individual will be travelling to the event?"
                    }
                    value={value?.travel}
                    onChange={(v) => this.handleChange('travel', v)}
                    options={(me) ? this.options.filter((e) => e.label !== 'Same as Store / Deputy Manager') : this.options}
                />

                {value?.travel === 'Train' &&
                    <>
                        <Input
                            label="Departure station"
                            value={value?.departure_station}
                            onChange={(v) => this.handleChange('departure_station', v)}
                        />

                        <Input
                            label="Time of train"
                            value={value?.time_of_train}
                            onChange={(v) => this.handleChange('time_of_train', v)}
                        />

                        <Input
                            label="Return station"
                            value={value?.return_station}
                            onChange={(v) => this.handleChange('return_station', v)}
                        />
                    </>
                }

                {value?.travel === 'Plane' &&
                    <>
                        <Input
                            label="Departure airport"
                            value={value?.departure_airport}
                            onChange={(v) => this.handleChange('departure_airport', v)}
                        />

                        <Input
                            label="Flight time"
                            value={value?.flight_time}
                            onChange={(v) => this.handleChange('flight_time', v)}
                        />

                        <Input
                            label="Name as on passport"
                            value={value?.name_as_on_passport}
                            onChange={(v) => this.handleChange('name_as_on_passport', v)}
                        />
                    </>
                }

                {value?.travel === 'Other' &&
                    <Textarea
                        label="Specify"
                        value={value?.specify}
                        onChange={(v) => this.handleChange('specify', v)}
                    />
                }
            </div>
        );
    }
}
